import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithPopover from './ButtonWithPopover';

function IntegrationCard({
    integrationInfo = {},
    connectIntegration = () => {},
    disconnectIntegration = () => {},
    upgradeIntegration = () => {},
}) {
    const buttonProps = { style: 'secondary', text: 'Purchase' };
    let block;
    if (integrationInfo.freeTrialUpgrade) {
        block = (
            <button
                onClick={() => upgradeIntegration(integrationInfo.slug)}
                className="btn btn--ghost pad-b-0px font-blue-48 cursor-pointer text-dec-underline"
            >
        Upgrade<i className="fas fa-arrow-right button-icon"></i>
            </button>
        );
    } else if (!integrationInfo.active) {
        block = (
            <button
                onClick={() => connectIntegration(integrationInfo)}
                className="btn btn--ghost pad-b-0px font-blue-48 cursor-pointer text-dec-underline"
            >
                {integrationInfo.configure ? 'Configure' : 'Connect'}
                <i className="fas fa-arrow-right button-icon"></i>
            </button>
        );
    } else {
        block = (
            <button
                onClick={() => disconnectIntegration(integrationInfo)}
                className="btn btn--ghost pad-b-0px font-blue-48 cursor-pointer text-dec-underline"
            >
        Disconnect<i className="fas fa-arrow-right button-icon"></i>
            </button>
        );
    }

    return (
        <>
            {integrationInfo ? (
                <div className="integration-card flex flex-wrap flex-dir-col align-items-start border-solid border-1px border-radius-10px border-color-gray-90" data-testid='integration-card'>
                    <div className="integration-card__content">
                        <div className="flex justify-content-space-between">
                            <img
                                className="integration-card__logo pad-b-4px"
                                src={integrationInfo.logo_url}
                                alt=""
                            />
                            {integrationInfo.active ? (
                                <div className="integration-card__tag--connected flex justify-content-space-between align-items-center"
                                    role="status"
                                    aria-label="Integration is connected">
                                    <svg
                                        aria-hidden="true"
                                        width="8"
                                        height="14"
                                        viewBox="0 0 8 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.39933 4.59998H4.51429L5.37975 1.35458C5.48125 0.973876 5.1939 0.599976 4.8 0.599976H1.39999C1.09926 0.599976 0.844987 0.822601 0.805262 1.12068L0.0053602 7.12069C-0.0426149 7.48042 0.237586 7.79999 0.600086 7.79999H3.56762L2.41614 12.6617C2.32624 13.0412 2.61647 13.4 2.99979 13.4C3.20854 13.4 3.40919 13.2907 3.51924 13.1006L7.91858 5.50061C8.14968 5.10143 7.86138 4.59998 7.39933 4.59998Z"
                                            fill="#004736"
                                        />
                                    </svg>
                  Connected
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className="flex">
                            <p className="integration-card__title margin-0px font-size-20px font-gray-16 font-w-6 flex-1">
                                {integrationInfo.name}
                            </p>
                            {integrationInfo.freeTrialUpgrade ? (
                                <ButtonWithPopover
                                    data-testid="upgrade-cta"
                                    class="margin-l-8px"
                                    ctaText={`Purchase a ThankView Plan to unlock the
                    ${integrationInfo.name} integration!`}
                                    ctaKey={integrationInfo.slug}
                                    button={buttonProps}
                                    ctaFunc={() => upgradeIntegration()}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                        <p className="integration-card__description margin-0px pad-b-8px font-gray-40 font-w-4">
                            {integrationInfo.description}
                        </p>
                    </div>
                    <div className="margin-buttons">{block}</div>
                </div>
            ) : (
                ''
            )}
        </>
    );
}

IntegrationCard.propTypes = {
    integrationInfo: PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
        logo_url: PropTypes.string,
        header: PropTypes.string,
        description: PropTypes.string,
        copy: PropTypes.string,
        configure: PropTypes.bool,
        callout: PropTypes.string,
    }).isRequired,
    connectIntegration: PropTypes.func.isRequired,
    disconnectIntegration: PropTypes.func.isRequired,
    upgradeIntegration: PropTypes.func.isRequired,
};

export default IntegrationCard;
